import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import Link from 'react-router/lib/Link';
import {FormattedMessage} from 'react-intl';
import {PERM_ADD_ORGANISATION} from '../../common/util/Permission';
import {hasPermission} from '../BrowserPermission';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {maxTextLength} from '../fw/Tool';

// This decorator (higher order component) fetches todos both in browser and
// on server side. It's true isomorphic data fetching and rendering.
class OrganisationChooser extends React.Component {
    static propTypes = {
        chooseOrganisation: PropTypes.func.isRequired,
		currentOrganisation: PropTypes.shape({
			name: PropTypes.string.isRequired
		}),
		organisations: PropTypes.arrayOf(PropTypes.shape({
			name: PropTypes.string.isRequired,
			realId: PropTypes.string.isRequired,
		})).isRequired
    };

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

	countMaxHeight() {
		return window.screen.height - 128 + 'px';
	}

	getRoute(org) {
		let routes = this.context.router.routes;

		if (routes[1].path !== "organisations/") {
			return this.context.router.location.pathname;
		}

		return `/organisations/${org.realId}/`;
	}

	getOrganisationItems() {
		let hasAnyLogo = false;
		for (let org of this.props.organisations) {
			if (org.logo) {
				hasAnyLogo = true;
				break;
			}
		}

		return this.props.organisations.sort((orgA, orgB) => {
			return orgA.name.localeCompare(orgB.name);
		}).map((org) => {
			let route = this.getRoute(org);

			return (<li key={org['id']}>
				<a href={route} onClick={(e) => {
					if (e.metaKey || e.shiftKey || e.ctrlKey || e.altKey) {
						return true;
					}

					this.props.chooseOrganisation(org);

					if (route !== this.context.router.getCurrentLocation().pathname) {
						this.context.router.push(route);
					} else {
						window.location.reload();
					}

					return false;
				}}>
					{hasAnyLogo ? (org['logo'] ? <img style={{maxWidth: '32px', maxHeight: '32px', filter: 'grayscale(1)', marginTop: '-12px', 'marginBottom': '-12px', marginLeft: '-15px', 'paddingRight': '5px'}} src={org['logo']} /> : <span style={{'paddingRight': '32px', marginLeft: '-15px'}} />) : null}{maxTextLength(org['name'])}
				</a>
			</li>);
		});
	}

    render() {
        let { organisations, currentOrganisation } = this.props;

        let canAddOrganisation = hasPermission(PERM_ADD_ORGANISATION);

        if (canAddOrganisation || organisations.length > 0) {
            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
						<span className="org-name">{currentOrganisation ? maxTextLength(currentOrganisation.name, 40) : <FormattedMessage defaultMessage="Choose organisation" id="organisation.choose"/>}</span>
						<span className="caret"></span>
					</a>
                    <ul className="dropdown-menu" role="menu">
                        {this.getOrganisationItems()}
                        {canAddOrganisation && organisations.length > 0 ? <li className="divider"/> : null}
                        {canAddOrganisation ? <li><Link to={urlMapping.getUrl(types['organisations'], 'create')}><span
                            className="glyphicon glyphicon-plus"/> <FormattedMessage
                            defaultMessage="Create new organisation" id="organisation.createNew"/></Link></li> : null}
                    </ul>
                </li>

            );
        } else {
            return null;
        }
    }
}

/*
 */

export default Relay.createContainer(OrganisationChooser, {
    fragments: {
        organisations: () => Relay.QL`
            fragment on Organisation @relay(plural: true) {
                id,
                realId,
				logo,
                name
            }
        `,
    },
});
